export enum ComponentNames {
  MobileMainMenu = 'MobileMainMenu',
  SiteLogin = 'SiteLogin',
  LoginMenuLinks = 'LoginMenuLinks',
  CategoriesMenu = 'CategoriesMenu',
  NavigationBarMobile = 'NavigationBarMobile',
  CartList = 'CartList',
  Comparison = 'Comparison',
}
